import * as actions from "./actionTypes";
import { CustomerAction } from "./actions";
import { CustomerDetails } from "./model";

// TODO: I want to know when we haven't even loaded it from the server yet
const defaultState: CustomerDetails = { phoneNumber: "", emailAddress: "", useToyotaTemplates: false };

export function customer(state: CustomerDetails = defaultState, action: CustomerAction): CustomerDetails {
    switch (action.type) {
        case actions.GET_CUSTOMER_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
